import Frames from "@frog/source/engine/animating/Frames.js"

export default {
    "static": require("./ranger-idle-0.png"),
    "idle": {
        "frames": Frames.run({
            "tweentime": 80,
            "images": [
                require("./ranger-idle-0.png"),
                require("./ranger-idle-0.png"),
                require("./ranger-idle-0.png"),
                require("./ranger-idle-0.png"),
                require("./ranger-idle-0.png"),
                require("./ranger-idle-0.png"),
                require("./ranger-idle-0.png"),
                require("./ranger-idle-0.png"),
                require("./ranger-idle-0.png"),
                require("./ranger-idle-0.png"),
                require("./ranger-idle-0.png"),
                require("./ranger-idle-1.png"),
                require("./ranger-idle-2.png"),
                require("./ranger-idle-3.png"),
                require("./ranger-idle-4.png"),
                require("./ranger-idle-5.png"),
                require("./ranger-idle-6.png"),
                require("./ranger-idle-7.png"),
            ]
        })
    },
    "ready": {
        "frames": Frames.run({
            "tweentime": 80,
            "images": [
                require("./ranger-selected-3.png"),
                require("./ranger-selected-4.png"),
                require("./ranger-selected-5.png"),
                require("./ranger-selected-6.png"),
                require("./ranger-selected-7.png"),
                require("./ranger-selected-0.png"),
                require("./ranger-selected-0.png"),
                require("./ranger-selected-0.png"),
                require("./ranger-selected-0.png"),
                require("./ranger-selected-1.png"),
                require("./ranger-selected-2.png"),
            ]
        })
    },
}
